module.exports = __webpack_public_path__ + "static/img/UTM老师_宫春吉.2f555e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM老师_宫春吉.png
// module id = 2wOW
// module chunks = 0